import React from 'react';
import '../css/entretenimiento.scss';
import Breadcrumbs from './Breadcrumbs';
import Footer from './Footer';
import musicaImg from '../assets/images/entretenimiento/musica.jpg';
import juegosImg from '../assets/images/entretenimiento/juego.jpg';

const entretenimientoData = [
  {
    image: musicaImg,
    title: 'Música a bordo',
    text: 'Disfruta de nuestro grupo musical durante la travesía en zona de restaurante o bar exterior.',
    note: 'Pregunta por su horario en recepción',
    icon: <i class="fi fi-rs-info"></i>
  },
  {
    image: juegosImg,
    title: '¡Entretenimiento sin pantallas!',
    text: 'Solicita nuestros juegos de mesa para divertirte con amigos y/o familia.',
    note: 'Sujeto a disponibilidad y deberán ser solicitados y entregados en recepción.',
    icon: 'casino'
  }
];

export default function Entretenimiento() {

  return (
    <>
      <section className="entretenimiento">
         {/* HERO */}
                <div className='entretenimiento-hero'>
                    <div className='overlay'></div>

                    <div className='container'>
                        <div className='hero-content'>

                            <div style={{ marginTop: '4rem' }} style={{ color: '#fff' }}>
                                <Breadcrumbs />
                            </div>

                            <h1>Entretenimiento a bordo</h1>

                            <p>
                                Información y requisitos necesarios para viajar de forma segura y cómoda
                                en nuestras embarcaciones.
                            </p>

                        </div>
                    </div>
                </div>


        {/* HERO */}
                <div className='embarazadas-hero'>

                    <div className='overlay'></div>

                    <div className='container hero-content'>

                        <div style={{ marginTop: '4rem' }}>
                            <Breadcrumbs />
                        </div>

                        <h1>
                           ¿Qué puedes hacer?
                        </h1>

                        <p>
                            Alternativas de Entretenimiento
                        </p>

                    </div>

                </div>

        <div className="container">

          <div className="entretenimiento-grid">

            {entretenimientoData.map((item, index) => (
              <div className="entretenimiento-card" key={index}>

                <div className="card-image">
                  <img
                    src={item.image}
                    alt={item.title}
                  />

                  <div className="card-overlay"></div>
                </div>

                <div className="card-content">

                  <h2>{item.title}</h2>

                  <p>
                    {item.text}
                  </p>

                  <div className="card-note">

                    <span className="material-symbols-outlined">
                      {item.icon}
                    </span>

                    <small>{item.note}</small>

                  </div>

                </div>

              </div>
            ))}

          </div>

        </div>
      </section>

      {/* CTA */}
      <section className="entretenimiento-cta">

        <div className="container">

          <div className="cta-box">

            <div className="cta-content">

              <h3>¿Listo para zarpar?</h3>

              <p>
                Reserva tu travesía y vive la experiencia Baja Ferries.
              </p>

            </div>

            <div className="cta-buttons">

                  <a href='https://www.bajaferries.com.mx/viaje-en-curso' target='_blank' rel="noreferrer" className='btn-primary'>
                    Ver itinerarios <i class="fi fi-rr-arrow-up-right-from-square"></i>
                  </a>
                  <a href='https://www.bajaferries.com.mx/preguntas-frecuentes' target='_blank' rel="noreferrer" className='btn-secondary'>
                    Preguntas Frecuentes <i class="fi fi-rr-arrow-up-right-from-square"></i>
                  </a>


            </div>

          </div>

        </div>

      </section>
      <Footer />
    </>
  );
}